import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { PasswordPolicy } from 'services/authentication/classes/password-policy';
import { PolicyData } from 'services/authentication/classes/policy-data';
import { CognitoService } from 'services/authentication/cognito/cognito.service';

@Component({
  selector: 'ems-password-policy',
  templateUrl: './password-policy.component.html',
  styleUrls: ['./password-policy.component.scss']
})
export class PasswordPolicyComponent implements OnInit {

  public get Title(): string {
    return this.labelPath('Title')
  }

  public get MinimumLengthLabel(): string {
    return this.labelPath('MinimumLength')
  }

  public get RequireUppercaseLabel(): string {
    return this.labelPath('RequireUppercase')
  }

  public get RequireLowercaseLabel(): string {
    return this.labelPath('RequireLowercase')
  }

  public get RequireNumbersLabel(): string {
    return this.labelPath('RequireNumbers')
  }

  public get RequireSymbolsLabel(): string {
    return this.labelPath('RequireSymbols')
  }

  public get MinimumLength(): number {
    return this.cognitoService.PasswordPolicy?.MinimumLength ?? 0
  }

  public get RequireUppercase(): boolean {
    return this.cognitoService.PasswordPolicy?.RequireUppercase ?? true
  }

  public get RequireLowercase(): boolean {
    return this.cognitoService.PasswordPolicy?.RequireLowercase ?? true
  }

  public get RequireNumbers(): boolean {
    return this.cognitoService.PasswordPolicy?.RequireNumbers ?? true
  }

  public get RequireSymbols(): boolean {
    return this.cognitoService.PasswordPolicy?.RequireSymbols ?? true
  }

  constructor(
    private cognitoService: CognitoService
  ) { }

  ngOnInit(): void {
    this.getPasswordPolicy()
  }

  private getPasswordPolicy(): void {
    if (!this.cognitoService.PasswordPolicy || this.cognitoService.PasswordPolicy.PoolId !== this.cognitoService.PoolId) {
      this.cognitoService.getPasswordPolicy(this.cognitoService.PoolId)
        .pipe(take(1))
        .subscribe((policyData: PolicyData) => {
          this.cognitoService.PasswordPolicy = PasswordPolicy.create(this.cognitoService.PoolId, policyData)
        })
    }
  }

  private labelPath(label: string): string {
    const prefix = 'password.policy.'
    return `${prefix}${label}`
  }
}
